import { defineMessages } from 'react-intl';

export default defineMessages({
    payee: {
        id: '_.your_company.repayment_card.payee',
        defaultMessage: 'Payee'
    },
    accountNumber: {
        id: '_.your_company.repayment_card.account_number',
        defaultMessage: 'Account number'
    },
    sortCode: {
        id: '_.your_company.repayment_card.sort_code',
        defaultMessage: 'Sort code'
    },
    iban: {
        id: '_.your_company.repayment_card.iban',
        defaultMessage: 'IBAN'
    },
    reference: {
        id: '_.your_company.repayment_card.reference',
        defaultMessage: 'Reference'
    },
    repaymentDetails: {
        id: '_.your_company.repayment_card.repayment_details',
        defaultMessage: 'repayment details'
    },
    chapsRepayments: {
        id: '_.your_company.repayment_card.chaps_repayments',
        defaultMessage:
            'CHAPS payments will not be accepted to this account. Please contact your Account Manager for alternative details.'
    }
});
